// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3aeyY","fullView":"styles_fullView__2VFAT"};